/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
// useGLTF to load GLTF model into the canvas
import { useAnimations, useGLTF } from '@react-three/drei'
import { TextureLoader } from 'three/src/loaders/TextureLoader'
import { useLoader } from '@react-three/fiber'
import { MeshStandardMaterial } from 'three';


const MODELS_BASEPATH = `${process.env.PUBLIC_URL}/models`
const TEXTURE_BASEPATH = `../assets/img`


export default function KanedaMoto(props) {

  const group = useRef()
  const { nodes, materials, animations } = useGLTF(`${MODELS_BASEPATH}/only_kaneda_moto.gltf`)
  const { actions } = useAnimations(animations, group)


  const mainMaterial = new MeshStandardMaterial({
    color: 0xFF1919,
  })
  const black = new MeshStandardMaterial({
    color: 0x000000,
  })
  const darkRed = new MeshStandardMaterial({
    color: 0x46231C,
  })
  const gray = new MeshStandardMaterial({
    color: 0x849294,
  })
  const darkGray = new MeshStandardMaterial({
    color: 0x141214,
  })
  const skinSeat = new MeshStandardMaterial({
    color: 0x683C20,
  })
  const orange = new MeshStandardMaterial({
    color: 0xD9753B,
  })

  const glassMaterial = new MeshStandardMaterial({
    color: 0x636363,
    transparent: true,
    opacity: 0.5
  })



  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group name="k_ruota_posteriore" position={[-0.147, 0, -0.147]}>
          <mesh
            name="Cylinder010"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder010.geometry}
            material={mainMaterial}
          />
          <mesh
            name="Cylinder010_1"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder010_1.geometry}
            material={black}
          />
          <mesh
            name="cosa_per_elettricità001"
            castShadow
            receiveShadow
            geometry={nodes.cosa_per_elettricità001.geometry}
            material={gray}
          />
        </group>
        <group name="k_manubrio" position={[-0.227, -0.01, -0.147]}>
          <mesh
            name="model_16001"
            castShadow
            receiveShadow
            geometry={nodes.model_16001.geometry}
            material={darkGray}
          />
          <mesh
            name="model_16001_1"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_1.geometry}
            material={mainMaterial}
          />
          <mesh
            name="model_16001_2"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_2.geometry}
            material={materials.schermo}
          />
          <mesh
            name="model_16001_3"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_3.geometry}
            material={materials['Specchio retrovisore']}
          />
          <mesh
            name="model_16001_4"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_4.geometry}
            material={mainMaterial}
          />
          <mesh
            name="model_16001_5"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_5.geometry}
            material={darkRed}
          />
          <mesh
            name="model_16001_6"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_6.geometry}
            material={darkRed}
          />
          <mesh
            name="model_16001_7"
            castShadow
            receiveShadow
            geometry={nodes.model_16001_7.geometry}
            material={orange}
          />
          <mesh
            name="buttone"
            castShadow
            receiveShadow
            geometry={nodes.buttone.geometry}
            material={materials['Button basso sin']}
            position={[-0.003, 0.13, 0]}
          />
          <mesh
            name="buttone001"
            castShadow
            receiveShadow
            geometry={nodes.buttone001.geometry}
            material={materials['Button alto sin']}
            position={[0.002, 0.112, 0]}
          />
          <mesh
            name="buttone002"
            castShadow
            receiveShadow
            geometry={nodes.buttone002.geometry}
            material={materials['Button alto sin']}
            position={[0, 0.116, 0]}
          />
          <mesh
            name="buttone003"
            castShadow
            receiveShadow
            geometry={nodes.buttone003.geometry}
            material={materials['Button destra']}
            position={[0, 0.118, 0]}
          />
          <mesh
            name="buttone004"
            castShadow
            receiveShadow
            geometry={nodes.buttone004.geometry}
            material={materials['Button basso sin']}
            position={[0.004, 0.107, 0]}
          />
          <mesh
            name="buttone005"
            castShadow
            receiveShadow
            geometry={nodes.buttone005.geometry}
            material={materials['Button basso sin']}
            position={[0.001, 0.116, 0]}
          />
          <mesh
            name="buttone006"
            castShadow
            receiveShadow
            geometry={nodes.buttone006.geometry}
            material={materials['Button basso sin']}
            position={[-0.003, 0.13, 0]}
          />
          <group name="k_ruota_frontale" position={[-0.1, 0, 0]}>
            <mesh
              name="Sphere"
              castShadow
              receiveShadow
              geometry={nodes.Sphere.geometry}
              material={mainMaterial}
            />
            <mesh
              name="Sphere_1"
              castShadow
              receiveShadow
              geometry={nodes.Sphere_1.geometry}
              material={black}
            />
            <mesh
              name="k_cerchione"
              castShadow
              receiveShadow
              geometry={nodes.k_cerchione.geometry}
              material={gray}
              position={[0, -0.006, 0]}
            />
          </group>
          <mesh
            name="parabrezza"
            castShadow
            receiveShadow
            geometry={nodes.parabrezza.geometry}
            material={glassMaterial}
          />
        </group>
        <mesh
          name="k_manubrio_scocca"
          castShadow
          receiveShadow
          geometry={nodes.k_manubrio_scocca.geometry}
          material={darkRed}
          position={[-0.227, -0.01, -0.147]}
        />
        <group name="k_manubrio_luce" position={[-0.227, -0.01, -0.147]}>
          <mesh
            name="model_16003"
            castShadow
            receiveShadow
            geometry={nodes.model_16003.geometry}
            material={darkRed}
          />
          <mesh
            name="model_16003_1"
            castShadow
            receiveShadow
            geometry={nodes.model_16003_1.geometry}
            material={materials['luce.piuForte']}
          />
        </group>
        <group
          name="k_corpo_moto"
          position={[-0.484, -0.354, 0.092]}
          rotation={[Math.PI / 2, -1.166, 0]}
          scale={[0.099, 0.096, 0.099]}>
          <mesh
            name="Cylinder008"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008.geometry}
            material={mainMaterial}
          />
          <mesh
            name="Cylinder008_1"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008_1.geometry}
            material={mainMaterial}
          />
          <mesh
            name="Cylinder008_2"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008_2.geometry}
            material={materials['Display 2.001']}
          />
          <mesh
            name="Cylinder008_3"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008_3.geometry}
            material={orange}
          />
          <mesh
            name="Cylinder008_4"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008_4.geometry}
            material={skinSeat}
          />
          <mesh
            name="Cylinder008_5"
            castShadow
            receiveShadow
            geometry={nodes.Cylinder008_5.geometry}
            material={mainMaterial}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload(`${MODELS_BASEPATH}/only_kaneda_moto.gltf`)